import React from "react";
import { Router } from "@reach/router";
import { navigate } from "gatsby";
import { connect } from "react-redux";
import {
  shortnameSelector,
  isLoggedIn,
  getAuthUser
} from "modules/session/selectors";
import { loadMyProfile, loadMissions } from "modules/playground/action";
import MissionPage from "components/MissionPage";
import { ThemeProvider } from "emotion-theming";
import { inverted } from "utils/themes";
import DashboardLayout from "components/DashboardLayout";
import DashboardPlayground from "components/DashboardPlayground";
import LeaderboardPage from "components/LeaderboardPage";
import MutationPage from "components/MutationPage";
import CataloguePage from "components/CataloguePage";
import SingleCataloguePage from "components/SingleCataloguePage";
import PlayIdPage from "components/PlayIdPage";

function Play(props) {
  React.useEffect(() => {
    if (props.isLoggedIn) {
      props.loadMyProfile();
      props.loadMissions();
    } else if (!props.isLoggedIn && typeof window !== "undefined") {
      navigate("/dashboard/login");
    }
  }, []);

  return (
    <ThemeProvider
      theme={inverted}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div style={{ padding: "24px 8px" }}>
        <Router>
          <DashboardLayout path="/play">
            <DashboardPlayground path="/" />
            <PlayIdPage path="/id" />
            <MissionPage path="/mission" />
            <LeaderboardPage path="/leaderboard" />
            <MutationPage path="/history" />
            <CataloguePage path="/catalogue" />
            <SingleCataloguePage path="/catalogue/:catalogueId" />
          </DashboardLayout>
        </Router>
      </div>
    </ThemeProvider>
  );
}

const withConnect = connect(
  state => ({
    name: shortnameSelector(state),
    isLoggedIn: isLoggedIn(state),
    user: getAuthUser(state)
  }),
  { loadMyProfile, loadMissions }
);

export default withConnect(Play);
